import { Grid, Typography } from "@mui/material";
import { DeviceFrameset } from "react-device-frameset";
import { Profile } from "@readyfit-common/models";
import DefaultAvatar from "src/grading/assets/images/avatar.png";
import RFModal from "src/grading/components/RFModal/RFModal";
import { useAppSelector } from "src/store/hooks";
import { selectCurrentUser } from "src/store/reducers/auth/authSlice";
import theme from "src/theme";
import BannerImage from "../../assets/images/banner-placeholder.png";
import useStyles from "./CoachPreviewModal.styles";
import "react-device-frameset/styles/marvel-devices.min.css";

interface CoachPreviewModalProps {
  onClose: () => void;
  open: boolean;
}

const CoachPreviewModal = ({ onClose, open }: CoachPreviewModalProps) => {
  const classes = useStyles();
  const profile: Profile = useAppSelector(selectCurrentUser);

  return (
    <RFModal
      open={open}
      boxProps={{ className: classes.container }}
      onClose={onClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid container>
        <Grid
          container
          item
          justifyContent="center"
          alignItems={"center"}
          py={theme.spacing(4)}
        >
          <Typography
            variant="caption"
            fontSize={"14px"}
            fontWeight={"bold"}
            textAlign={"center"}
            textTransform={"uppercase"}
            sx={{ whiteSpace: "pre-line" }}
          >
            {`This is how an athlete will\nsee your profile`}
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="center"
          className={classes.phoneContainer}
        >
          <DeviceFrameset device="iPhone X" color="black" height={750}>
            <div className={classes.profileCard}>
              <div className={classes.banner}>
                {/* <Typography
                  variant={"h3"}
                  className={classes.bannerOverlayText}
                  textAlign={"center"}
                >
                  COACH PROFILE
                </Typography> */}
                <img
                  src={profile?.coachInfo?.images?.[0] || BannerImage}
                  alt="Banner Image"
                />
              </div>
              <div className={classes.avatarWrapper}>
                <img
                  src={profile?.profileImageUrl || DefaultAvatar}
                  alt="Avatar"
                  className={`${classes.avatar} ${
                    !profile?.profileImageUrl ? classes.placeholder : ""
                  }`}
                />
              </div>
              <Grid className={classes.content}>
                <Typography variant="h4" textAlign="center">
                  {profile?.firstName} {profile?.lastName}
                </Typography>
                <Grid container item className={classes.membership}>
                  <Typography variant="caption" color={"#C2C2C2"}>
                    Membership
                  </Typography>
                  <Typography variant="h5" fontSize={"18px"}>
                    $49.99
                  </Typography>
                </Grid>
                {profile?.coachInfo?.specialties && (
                  <Grid container item className={classes.specialties}>
                    <Grid container item>
                      <Typography
                        color={"#8F8F8F"}
                        fontSize={"12px"}
                        variant="caption"
                        textTransform={"uppercase"}
                      >
                        Specialties
                      </Typography>
                    </Grid>
                    <Grid container>
                      <ul>
                        {profile?.coachInfo?.specialties?.map(
                          (specialty, index) => (
                            <li key={index}>
                              <Typography variant="caption">
                                {specialty}
                              </Typography>
                            </li>
                          ),
                        )}
                      </ul>
                    </Grid>
                  </Grid>
                )}

                {profile?.coachInfo?.aboutMe && (
                  <Grid container item className={classes.about}>
                    <Typography
                      color={"#8F8F8F"}
                      fontSize={"12px"}
                      variant="caption"
                      textTransform={"uppercase"}
                    >
                      About Me
                    </Typography>
                    <Grid container>
                      <Typography
                        variant="caption"
                        marginTop={theme.spacing(1)}
                      >
                        {profile?.coachInfo?.aboutMe}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </div>
          </DeviceFrameset>
        </Grid>
      </Grid>
    </RFModal>
  );
};

export default CoachPreviewModal;
